module.exports = __webpack_public_path__ + "static/media/ATS-V2-SiegeSocial.77bd914d.jpg";